import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { Info } from '@vy/ui-design-system';
import type { AccountInput } from '@vy/types';
import type { Control } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';
import { VyDialog } from '../../../../../../components/new-design/feedback/VyDialog';
import { useDialog } from '../../../../../../hooks/use-dialog';
import { VyTooltip } from '../../../../../../components/new-design/VyTooltip';

type Props = {
  control: Control<AccountInput, unknown>;
};

export const IssueOnApprovalField: React.FC<Props> = ({ control }) => {
  const { formState } = useFormContext<AccountInput>();
  const confirmDialog = useDialog();
  const savedValue = formState.defaultValues?.settings?.invoicingSettings?.issueOnApproval;

  return (
    <Controller
      name="settings.invoicingSettings.issueOnApproval"
      control={control}
      render={({ field }) => (
        <>
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value ?? false}
                onChange={(e) => {
                  if (savedValue) {
                    return;
                  }

                  if (!e.target.checked) {
                    field.onChange(false);

                    return;
                  }

                  confirmDialog.handleOpen();
                }}
              />
            }
            label={
              <Stack direction="row" sx={{ alignItems: 'center', gap: '6px' }}>
                <span>Set issue date and due date only upon approval</span>
                {savedValue && (
                  <VyTooltip placement="right" tooltipContent={<><div>This setting cannot be reverted independently</div><div>Contact support to disable this setting.</div></>}>
                    <span style={{ display: 'flex' }}>
                      <Info width={16} height={16} />
                    </span>
                  </VyTooltip>
                )}
              </Stack>
            }
          />
          <VyDialog
            open={confirmDialog.isDialogOpen}
            onClose={confirmDialog.handleClose}
            label="Enable issue on approval"
            labelDescription="This setting cannot be reverted independently."
            cancelButtonText="Cancel"
            ctaText="Confirm"
            disableDividers
            onSubmit={() => {
              field.onChange(true);
              confirmDialog.handleClose();
            }}
          />
        </>
      )}
    />
  );
};
